import React, { useEffect, useState } from "react";
// import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import Head from "next/head";
import striptags from "striptags";
import Link from "next/link";
import dynamic from "next/dynamic";
import Image from "next/image";

const Loader = dynamic(() => import("../../components/common/Loader/Loader"));
const Layout = dynamic(() => import("../../components/common/Layout/Layout"));
const CommonCtaSection = dynamic(() =>
  import("../../components/common/CTASection/CommonCtaSection")
);

const CaseStudy = ({ apiData, caseData, footerData }) => {
  const commonCtaData = apiData?.body?.find((block) => block?.type === "cta");
  const casepage = apiData;
  const casedata = caseData;
  const webLogo = footerData;
  const [headerData, setHeaderData] = useState();
  const [loader, setLoader] = useState(true);
  const [searchInput, setSearchInput] = useState("");
  const [filterCaseData, setFilterCaseData] = useState([]);
  const heading = headerData?.heading;
  const title = casepage?.page_title;
  const seo_title = casepage?.meta?.seo_title;
  const canonicalUrl = apiData?.canonical_url;
  const search_description = casepage?.meta?.search_description;
  const og_title = apiData?.og_title;
  const og_description = apiData?.og_description;
  const og_image = apiData?.og_image?.url;
  const [industryData, setIndustryData] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [caseStudyData, setCaseStudyData] = useState();
  const itemsPerPage = 2;

  // Calculate the start and end indexes for the items to display
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = currentPage * itemsPerPage;
  const visibleItems =
    filterCaseData.length > 0
      ? filterCaseData && filterCaseData.slice(startIndex, endIndex)
      : caseStudyData && caseStudyData.slice(startIndex, endIndex);

  const totalPages = Math.ceil(
    filterCaseData.length
      ? filterCaseData && filterCaseData.length / itemsPerPage
      : caseStudyData && caseStudyData.length / itemsPerPage
  );

  const structuredData = apiData?.struct_org_extra_json;
  const formatJson = (json) => {
    return {
      __html: `${json}`,
    };
  }

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const searchData = () => {
    const searchResult = caseStudyData.filter((blog) =>
      blog.industry.toLowerCase().includes(searchInput?.toLowerCase())
    );
    setFilterCaseData(searchResult);
    setCurrentPage(1);
  };

  useEffect(() => {
    caseStudyData && searchData();
  }, [searchInput]);

  useEffect(() => {
    const head = casepage;
    head && setHeaderData(head);
    const data = casedata?.serializer?.results;
    const industry_data = casedata?.industry;
    industry_data && setIndustryData(industry_data);
    data && setCaseStudyData(data);
  }, [casepage, casedata]);

  useEffect(() => {
    webLogo && setLoader(false);
  }, []);

  return (
    <>
      <Head>
        <title>{striptags(title)}</title>

        <meta name="title" content={seo_title} key="og-title" />

        <meta name="description" content={search_description} key="og-desc" />
        <link rel="canonical" href={canonicalUrl} />
        <meta property="og:title" content={og_title || seo_title} />
        <meta property="og:description" content={og_description || search_description} />
        <meta property="og:image" content={og_image} />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Quixom" />
        {structuredData && (
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={formatJson(structuredData)}
          />
        )}
      </Head>
      <Layout webLogo={webLogo && webLogo?.site_configuration[0]?.logo?.url}>
        {loader && <Loader />}
        <main className="main-wrapper case-studies-middle wrapper-top-bg">
          <article className="wrapper-inner">
            <section className="casestudies-hero-section light-primary-background">
              <div className="casestudies-hero-inner">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="heading">
                        <span
                          className="heading-h1"
                          itemProp="heading"
                          dangerouslySetInnerHTML={{
                            __html: heading,
                          }}
                        ></span>
                        <p
                          itemProp="description"
                          dangerouslySetInnerHTML={{
                            __html: headerData?.description,
                          }}
                        ></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="casestudies-stories-section">
              <div className="casestudies-stories-inner">
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="casestudies-category-tab">
                        <ul
                          className="nav casestudies-category-nav"
                          id="pills-tab"
                          role="tablist"
                        >
                          <li className="nav-item" role="presentation">
                            <button
                              className={`nav-link ${!searchInput && "active"}`}
                              id="pills-home-tab"
                              data-bs-toggle="pill"
                              data-bs-target="#pills-home"
                              type="button"
                              role="tab"
                              aria-controls="pills-home"
                              aria-selected="true"
                              onClick={() => setSearchInput("")}
                            >
                              All
                            </button>
                          </li>
                          {industryData?.map((val, index) => {
                            return (
                              <li
                                className="nav-item"
                                role="presentation"
                                key={index}
                              >
                                <button
                                  className={`nav-link ${searchInput && searchInput === val?.name
                                      ? "active"
                                      : ""
                                    }`}
                                  id="pills-profile-tab"
                                  data-bs-toggle="pill"
                                  data-bs-target={`#${index}`}
                                  type="button"
                                  role="tab"
                                  aria-controls={index}
                                  aria-selected="false"
                                  onClick={() => {
                                    setSearchInput(val?.name);
                                  }}
                                >
                                  {val?.name}
                                </button>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="tab-content" id="pills-tabContent">
                        <div
                          className="tab-pane fade show active"
                          id="pills-home"
                          role="tabpanel"
                          aria-labelledby="pills-home-tab"
                        >
                          <div className="casestudies-stories-list">
                            <div className="row">
                              {visibleItems?.map((val, ind) => {
                                return (
                                  <div key={ind} className="col-md-6 col-sm-6">
                                    <div className="casestudies-stories-card">
                                      <div className="casestudies-thumbnail">
                                        <Link href="#" itemProp="link">
                                          {val?.banner?.map((val, index) => {
                                            if (val?.type == "image") {
                                              return (
                                                <Image
                                                  height={100}
                                                  width={100}
                                                  key={`${index}_k`}
                                                  src={val?.value?.url}
                                                  alt={val?.value?.alt_text ?? 'Streamlining Business Operations With a Digital Management System'}
                                                  loading="eager"
                                                />
                                              );
                                            }
                                          })}
                                        </Link>
                                      </div>
                                      <div className="casestudies-content">
                                        <div className="casestudies-details">
                                          <h3 itemProp="heading">
                                            <Link href="#" itemProp="link">
                                              {val?.title}
                                            </Link>
                                          </h3>
                                          {val?.overview?.map((val, index) => {
                                            if (val?.type == "project") {
                                              return (
                                                <div
                                                  className="casestudy-text"
                                                  key={`${index}_k`}
                                                >
                                                  <p>
                                                    {striptags(
                                                      val?.value?.description
                                                    )}
                                                  </p>
                                                </div>
                                              );
                                            }
                                          })}
                                        </div>
                                        <div className="casestudies-readmore-btn">
                                          <Link
                                            href={`/case-studies/${val?.slug}`}
                                            className="casestudies-readmore btn"
                                            onClick={() => {
                                              localStorage.setItem(
                                                "caseStudy",
                                                val?.slug
                                              );
                                            }}
                                          >
                                            <span>Read More</span>
                                          </Link>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="article-pagination">
                        <nav aria-label="...">
                          <ul className="pagination">
                            <li className="page-item">
                              <Link
                                className="page-link"
                                href="#!"
                                tabIndex="-1"
                                aria-disabled="true"
                                onClick={() =>
                                  handlePageChange(currentPage - 1)
                                }
                              >
                                Prev
                              </Link>
                            </li>
                            {Array.from({ length: totalPages }, (_, i) => (
                              <li
                                key={i}
                                className={`page-item ${i + 1 === currentPage ? "active" : ""
                                  }`}
                              >
                                <Link
                                  className="page-link"
                                  href="#!"
                                  onClick={() => handlePageChange(i + 1)}
                                >
                                  {i + 1}
                                </Link>
                              </li>
                            ))}
                            <li className="page-item">
                              <Link
                                className="page-link"
                                href="#!"
                                onClick={() =>
                                  handlePageChange(currentPage + 1)
                                }
                              >
                                Next
                              </Link>
                            </li>
                          </ul>
                        </nav>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <CommonCtaSection data={commonCtaData} />
          </article>
        </main>
      </Layout>
    </>
  );
};

export async function getServerSideProps() {
  // Fetch data from your API
  const [apiResponse, caseListResponse, footerLogoResponse] = await Promise.all(
    [
      fetch(process.env.NEXT_PUBLIC_API_ENDPOINT + "/cms/pages/case-studies/"),
      fetch(process.env.NEXT_PUBLIC_API_ENDPOINT + "/case-studies/list"),
      fetch(process.env.NEXT_PUBLIC_API_ENDPOINT + "/footer/"),
    ]
  );

  const [apiData, caseData, footerData] = await Promise.all([
    apiResponse.json(),
    caseListResponse.json(),
    footerLogoResponse.json(),
  ]);

  if (apiData?.redirect_url) {
    return {
      redirect: {
        destination: apiData.redirect_url,
        permanent: false,
      },
    };
  }

  return {
    props: {
      apiData,
      caseData,
      footerData,
    },
  };
}
export default CaseStudy;
